import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';

/* eslint-disable import/prefer-default-export */

export var content = /*#__PURE__*/css("height:0;margin:0 16px;border-bottom:1px solid ", variables.colour.neutral200, ";");